import React from "react";

import isSameDay from "date-fns/isSameDay"
import format from "date-fns/format"

import { TIME_FORMAT, DATE_FORMAT, DATE_TIME_FORMAT } from "../../../constants/formats";


interface ITimeRangeDisplayProps {
    start: Date;
    end: Date;
}

export const TimeRangeDisplay: React.FC<ITimeRangeDisplayProps> = ({ start, end }) => {
    // Check if the date is the same on both start and end dates. This is so we know
    // only display the date once instead of two same dates. The exact hours does the same,
    // except it controls whether or not we display minutes too.
    const exactHours = (start.getMinutes() === 0) && (end.getMinutes() === 0);

    const timeFormat = exactHours ? "HH" : TIME_FORMAT;
    const startH = format(start, timeFormat);
    const endH = format(end, timeFormat);

    if (isSameDay(start, end)) {
        const date = format(start, DATE_FORMAT);

        return <span>{date} klo {startH} - {endH}</span>;
    } else {
        const startD = format(start, DATE_TIME_FORMAT);
        const endD = format(end, DATE_TIME_FORMAT);

        return <span>{startD} - {endD}</span>
    }
};
